import { Modal } from "@components/ui";
import cn from "clsx";
import { EModalType } from "@middleware/types";
import React from "react";
import { setToStorage } from "@middleware/helpers/global/sessions";
import {
  MAIL_CAPTURE_MODAL,
  MAIL_CAPTURE_SUBMITTED,
  UTM_POPUP,
} from "@middleware/constants";
import { PrismicRichText } from "@prismicio/react";
import { Content } from "@prismicio/client";
import Benefits from "./Benefits";
import Background from "../ModalBackground/Background";
import { TitlePage } from "../../TitlePage/TitlePage";
import RegisterByMailForm from "./RegisterByMailForm/RegisterByMailForm";
import style from "./EmailCaptureModal.module.scss";
import style2 from "../Modals.module.scss";

interface Props {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  mailSubmitted?: () => void;
  modalContent?:
    | Content.EmailCapturePopupDocument
    | Content.EmailCapturePopupStagingDocument;
}
export default function EmailCaptureModal({
  isOpen,
  setIsOpen,
  mailSubmitted,
  modalContent,
}: Props) {
  const handleClosingModal = () => {
    setIsOpen(false);
    setToStorage(MAIL_CAPTURE_MODAL, "true");
  };
  const afterMailCaptured = () => {
    setToStorage(MAIL_CAPTURE_SUBMITTED, "true");
    handleClosingModal();
    if (mailSubmitted) mailSubmitted();
  };

  return isOpen ? (
    <div className={cn(style.referralModal, style2.globalModal)}>
      <Modal
        onClose={handleClosingModal}
        variant={EModalType.FIXED}
        className={cn(style.modal, style2.modal)}
      >
        <Background modalContent={modalContent} />
        <div className={style.wrapper}>
          <TitlePage className={style.title}>
            <PrismicRichText field={modalContent?.data.title} />
          </TitlePage>
          <Benefits modalContent={modalContent} />
          <RegisterByMailForm
            className={style.form}
            submitText={modalContent?.data.buttonLabel}
            afterSubmit={afterMailCaptured}
            utms={{ utm_campaign: UTM_POPUP }}
          />
          <div className={style.terms}>
            <PrismicRichText field={modalContent?.data.termsFooter} />
          </div>
        </div>
      </Modal>
    </div>
  ) : null;
}
